/**
 * @module lib/date
 * Utilities for working with dates.
 * Heavily relies on [Moment.js]{@link https://momentjs.com/}.
 */

import moment from "moment";

export function now() {
  return new moment();
}

export function nowString(){
  return now().unix();
}

/**
 * Work out the date n days after the given date
 *
 * @param {moment-compatible-date} startDate
 * @param {number} dayCount
 * @returns {Date}
 */
export function addDays(startDate, dayCount) {
  return moment(startDate).add(dayCount, "days").toDate();
}

/**
 * Work out the number of days between two dates
 
 * @param {moment-compatible-date} firstDate
 * @param {moment-compatible-date} secondDate
 * @returns {number}
 */
export function getDayDiff(firstDate, secondDate) {
  return moment(firstDate).diff(secondDate, "days");
}

/**
 * Array of the days of the week (convenient for iterating over)
 */
export const WEEKDAYS = [ "Monday", "Tuesday", "Wednesday", "Thursday", "Friday" ];

/**
 * Check if the given date is earlier than today
 *
 * @param {moment-compatible-date} date
 * @returns {boolean}
 */
export function isDatePast(date) {
  return moment(date).isBefore(moment(), "day");
}



// WEBPACK FOOTER //
// ./src/lib/date/index.js